module.exports = __webpack_public_path__ + "img/home.8389a86b.svg";